/* Collection-only navigation. Shopify still renders every filter result. */
(function () {
  'use strict';

  function copyUrl(value) { return new URL(value.href || value); }
  function isCollectionUrl(value, base) {
    try {
      var url = copyUrl(value);
      return /^https?:$/.test(url.protocol) && url.origin === base.origin
        && url.pathname.replace(/\/$/, '') === base.pathname.replace(/\/$/, '');
    } catch (_) { return false; }
  }
  function setValues(params, name, values) {
    params.delete(name);
    values.forEach(function (value) { params.append(name, value); });
  }
  function toggleFilter(value, name, item) {
    var url = copyUrl(value);
    var values = url.searchParams.getAll(name);
    if (values.indexOf(item) === -1) values.push(item);
    else values = values.filter(function (entry) { return entry !== item; });
    setValues(url.searchParams, name, values);
    url.searchParams.delete('page');
    return url;
  }
  function removeActiveFilter(value, rendered, destination) {
    var url = copyUrl(value);
    var names = Array.from(new Set(Array.from(rendered.searchParams.keys())));
    names.filter(function (name) { return name.indexOf('filter.') === 0; }).forEach(function (name) {
      if (/^filter\.v\.price\.(gte|lte)$/.test(name) && !destination.searchParams.has(name)) {
        url.searchParams.delete(name);
        return;
      }
      var retained = destination.searchParams.getAll(name).slice();
      var removed = rendered.searchParams.getAll(name).filter(function (item) {
        var index = retained.indexOf(item);
        if (index === -1) return true;
        retained.splice(index, 1);
        return false;
      });
      var desired = url.searchParams.getAll(name);
      removed.forEach(function (item) {
        var index = desired.indexOf(item);
        if (index !== -1) desired.splice(index, 1);
      });
      setValues(url.searchParams, name, desired);
    });
    url.searchParams.delete('page');
    return url;
  }
  function clearFilters(value) {
    var url = copyUrl(value);
    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name.indexOf('filter.') === 0 || name === 'page') url.searchParams.delete(name);
    });
    return url;
  }

  // Node-only exports let the exact URL logic be tested without a browser.
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = {
      isCollectionUrl: isCollectionUrl,
      toggleFilter: toggleFilter,
      removeActiveFilter: removeActiveFilter,
      clearFilters: clearFilters
    };
    return;
  }
  if (window.__larkCollectionNavigation) return;
  if (!window.fetch || !window.AbortController || !window.DOMParser
      || !window.URL || !window.URLSearchParams || !window.history.pushState) return;
  window.__larkCollectionNavigation = { version: 2 };

  function start() {
    var data = document.querySelector('script[data-section-type="static-collection-faceted-filters"]');
    var root = data && data.closest('[id^="shopify-section-"]');
    // Skylar's custom carousel has no section reload lifecycle; keep its native navigation.
    if (!root || !data.dataset.sectionId || root.querySelector('.interline-slick')) return;
    var sectionId = data.dataset.sectionId;
    var rootId = root.id;
    var originalUrl = new URL(window.location.href);
    var state = {
      root: root, rendered: copyUrl(originalUrl), desired: copyUrl(originalUrl),
      sequence: 0, controller: null, priceTimer: null, busy: false, updates: 0
    };
    var historyKey = '__larkCollectionNavigation';
    var status = document.createElement('span');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
    root.after(status);

    function actualRoot() { return document.getElementById(rootId); }
    function collectionModal() {
      if (!document.body.classList.contains('modal-visible')) return null;
      return document.querySelector('[data-modal-container].modal--productgrid-sidebar, [data-modal-container].modal--productgrid-sort');
    }
    function inScope(element) {
      var current = actualRoot();
      var modal = collectionModal();
      return !!(current && (current.contains(element) || (modal && modal.contains(element))));
    }
    function historyData(scroll) {
      var previous = window.history.state;
      var result = previous && typeof previous === 'object' ? Object.assign({}, previous) : {};
      result[historyKey] = { path: originalUrl.pathname, scroll: scroll };
      return result;
    }
    function scrollPosition() { return { x: window.scrollX, y: window.scrollY }; }
    function saveScroll() {
      window.history.replaceState(historyData(scrollPosition()), '', window.location.href);
    }
    function cleanUrl(value) {
      var url = copyUrl(value);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      return url;
    }
    function busy(value) {
      state.busy = value;
      var current = actualRoot();
      if (current) {
        current.dataset.larkCollectionNavigation = value ? 'loading' : 'ready';
        current.dataset.larkCollectionUpdates = String(state.updates);
      }
      [actualRoot(), collectionModal()].filter(Boolean).forEach(function (element) {
        if (value) element.setAttribute('aria-busy', 'true');
        else element.removeAttribute('aria-busy');
        element.style.cursor = value ? 'progress' : '';
      });
      status.textContent = value ? 'Updating products…' : 'Products updated.';
    }
    function fallback(value) {
      if (state.controller) state.controller.abort();
      var destination = cleanUrl(value);
      // Keep the current preview cookie; replaying its bootstrap drops repeated filters.
      destination.searchParams.delete('preview_theme_id');
      window.location.assign(destination.href);
    }
    function focusDescription(element) {
      if (!element || !inScope(element)) return null;
      var target = element.closest('[data-filter-input], [data-filter-range], [data-productgrid-trigger-sort], [data-productgrid-trigger-sort-button], [data-collection-view], .pagination--item');
      if (!target) return null;
      if (target.hasAttribute('data-name')) return { type: 'facet', name: target.dataset.name, value: target.dataset.value };
      if (target.hasAttribute('data-filter-range')) return { type: 'range', name: target.name };
      if (target.hasAttribute('data-collection-view')) return { type: 'view', value: target.dataset.collectionView };
      if (target.hasAttribute('data-productgrid-trigger-sort') || target.hasAttribute('data-productgrid-trigger-sort-button')) return { type: 'sort' };
      return { type: 'heading' };
    }
    function groupLabel(button) { return button.textContent.trim(); }
    function captureView(focus) {
      var modal = collectionModal();
      var scope = [actualRoot(), modal].filter(Boolean);
      var openGroups = [];
      scope.forEach(function (element) {
        element.querySelectorAll('[data-filter-group-trigger]').forEach(function (button) {
          if (button.getAttribute('aria-expanded') === 'true') openGroups.push(groupLabel(button));
        });
      });
      return {
        scroll: scrollPosition(), groups: openGroups,
        modal: modal && modal.classList.contains('modal--productgrid-sidebar') ? 'filters' : null,
        focus: focusDescription(document.activeElement) || focus
      };
    }
    async function closeModal() {
      var modal = collectionModal();
      if (!modal) return;
      // Escape runs the theme wrapper's close method, including its key-listener cleanup.
      window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      if (collectionModal()) {
        var close = modal.querySelector('[data-modal-close]');
        if (close) close.click();
      }
      await new Promise(function (resolve) { window.requestAnimationFrame(resolve); });
      if (collectionModal()) throw new Error('Collection modal did not close');
    }
    function restoreView(view) {
      var current = actualRoot();
      current.querySelectorAll('[data-filter-group-trigger]').forEach(function (button) {
        var wanted = view.groups.indexOf(groupLabel(button)) !== -1;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        if (wanted !== expanded) button.click();
      });
      if (view.revealResults) {
        var results = current.querySelector('[data-productgrid-outer]') || current;
        var header = document.querySelector('header.site-header');
        var headerOffset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        view.scroll = { x: 0, y: Math.max(0, results.getBoundingClientRect().top + window.scrollY - headerOffset - 20) };
        window.scrollTo({ left: view.scroll.x, top: view.scroll.y,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      } else window.scrollTo(view.scroll.x, view.scroll.y);
      if (view.modal === 'filters') {
        var trigger = current.querySelector('[data-productgrid-trigger-filters]');
        if (trigger) trigger.click();
      }
      var scope = collectionModal() || current;
      var description = view.focus;
      var target;
      if (view.revealResults) {
        target = current.querySelector('[data-productgrid-outer]') || current;
      } else if (description && description.type === 'facet') {
        target = Array.from(scope.querySelectorAll('[data-filter-input][data-name]')).find(function (element) {
          return element.dataset.name === description.name && element.dataset.value === description.value;
        });
      } else if (description && description.type === 'range') {
        target = Array.from(scope.querySelectorAll('[data-filter-range]')).find(function (element) { return element.name === description.name; });
      } else if (description && description.type === 'view') {
        target = Array.from(current.querySelectorAll('[data-collection-view]')).find(function (element) { return element.dataset.collectionView === description.value; });
      } else if (description && description.type === 'sort') {
        target = current.querySelector('[data-productgrid-trigger-sort]');
        if (!target || !target.getClientRects().length) target = current.querySelector('[data-productgrid-modal-sort]');
      }
      if (!target || !target.getClientRects().length) {
        target = view.modal === 'filters' ? scope.querySelector('[data-filter-group-trigger]') : current.querySelector('.collection--title');
      }
      if (target) {
        if (!target.matches('a,button,input,select,[tabindex]')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    async function navigate(value, options) {
      options = options || {};
      var target = cleanUrl(value);
      if (!isCollectionUrl(target, originalUrl)) return;
      clearTimeout(state.priceTimer);
      state.priceTimer = null;
      var sequence = ++state.sequence;
      if (state.controller) state.controller.abort();
      state.controller = new AbortController();
      state.desired = copyUrl(target);
      if (!options.pop) saveScroll();
      busy(true);
      var timedOut = false;
      var controller = state.controller;
      var timeout = setTimeout(function () {
        if (sequence !== state.sequence) return;
        timedOut = true;
        controller.abort();
      }, 15000);
      try {
        // The preview cookie is established before this script runs. Replaying
        // preview_theme_id bootstraps preview again and can drop repeated filters.
        var request = copyUrl(target);
        request.searchParams.delete('preview_theme_id');
        request.searchParams.set('section_id', sectionId);
        var response = await fetch(request.href, {
          signal: state.controller.signal, credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok || !isCollectionUrl(response.url, originalUrl)) throw new Error('Collection request failed');
        var html = await response.text();
        if (sequence !== state.sequence) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.getElementById(rootId);
        var replacementData = replacement && replacement.querySelector('script[data-section-type="static-collection-faceted-filters"]');
        if (!replacementData || replacementData.dataset.sectionId !== sectionId
            || !replacement.querySelector('[data-productgrid-outer]')
            || !replacement.querySelector('[data-productgrid-items], .productgrid--no-results')) {
          throw new Error('Collection response was incomplete');
        }
        var view = captureView(options.focus);
        if (options.scroll) view.scroll = options.scroll;
        if (options.revealResults && !options.pop) {
          view.revealResults = true;
          view.modal = null;
        }
        await closeModal();
        if (sequence !== state.sequence) return;
        var previous = actualRoot();
        if (!previous) throw new Error('Collection section missing');
        previous.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: sectionId } }));
        previous.replaceWith(replacement);
        state.root = replacement;
        if (!options.pop) window.history.pushState(historyData(view.scroll), '', target.href);
        state.rendered = copyUrl(target);
        replacement.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
        ++state.updates;
        await new Promise(function (resolve) { window.requestAnimationFrame(resolve); });
        if (sequence !== state.sequence) return;
        restoreView(view);
        if (view.revealResults) window.history.replaceState(historyData(view.scroll), '', target.href);
        busy(false);
      } catch (error) {
        if (sequence !== state.sequence || (error.name === 'AbortError' && !timedOut)) return;
        fallback(target);
      } finally {
        clearTimeout(timeout);
      }
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    function safeLink(element) {
      if (element.hasAttribute('download') || (element.target && element.target !== '_self')) return null;
      try {
        var url = new URL(element.getAttribute('href'), window.location.href);
        return isCollectionUrl(url, originalUrl) ? url : null;
      } catch (_) { return null; }
    }
    function onClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      var target = event.target.closest('a[data-filter-input], a.filter-item-clear-all, .pagination--container a, button[data-productgrid-trigger-sort-button], button[data-collection-view]');
      if (!target || !inScope(target)) return;
      var next = copyUrl(state.desired);
      if (target.matches('a')) {
        var destination = safeLink(target);
        if (!destination) return;
        stop(event);
        if (target.hasAttribute('data-disabled') || target.getAttribute('aria-disabled') === 'true') return;
        if (target.matches('.filter-item-clear-all')) next = clearFilters(next);
        else if (target.matches('.pagination--container a')) {
          var page = destination.searchParams.get('page');
          if (page) next.searchParams.set('page', page);
          else next.searchParams.delete('page');
        } else if (target.hasAttribute('data-name') && target.hasAttribute('data-value')) {
          next = toggleFilter(next, target.dataset.name, target.dataset.value);
        } else next = removeActiveFilter(next, state.rendered, destination);
      } else {
        stop(event);
        if (target.disabled) return;
        if (target.hasAttribute('data-collection-view')) next.searchParams.set('grid_list', target.dataset.collectionView);
        else { next.searchParams.set('sort_by', target.value); next.searchParams.delete('page'); }
      }
      navigate(next, { focus: focusDescription(target),
        revealResults: target.matches('a[data-filter-input], a.filter-item-clear-all') });
    }
    function updatePrice(input, immediate) {
      var form = input.closest('form');
      if (!form) return;
      clearTimeout(state.priceTimer);
      state.priceTimer = null;
      // A keystroke is a newer intent even before its debounce expires.
      ++state.sequence;
      if (state.controller) state.controller.abort();
      var fields = Array.from(form.querySelectorAll('[data-filter-range]'));
      if (fields.some(function (field) { return field.value !== '' && (!field.validity.valid || !Number.isFinite(Number(field.value))); })) {
        busy(false);
        return;
      }
      var next = copyUrl(state.desired);
      fields.forEach(function (field) {
        if (field.value === '') next.searchParams.delete(field.name);
        else next.searchParams.set(field.name, field.value);
      });
      next.searchParams.delete('page');
      state.desired = next;
      if (immediate) navigate(next, { focus: focusDescription(input), revealResults: true });
      else {
        busy(true);
        state.priceTimer = setTimeout(function () { navigate(state.desired, { focus: focusDescription(input), revealResults: true }); }, 500);
      }
    }
    document.addEventListener('click', onClick, true);
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!inScope(target)) return;
      if (target.matches('[data-filter-range]')) { event.stopImmediatePropagation(); updatePrice(target, false); }
      else if (target.matches('[data-productgrid-trigger-sort]')) {
        stop(event);
        var next = copyUrl(state.desired);
        next.searchParams.set('sort_by', target.value);
        next.searchParams.delete('page');
        navigate(next, { focus: focusDescription(target) });
      }
    }, true);
    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-filter-range]') && inScope(event.target)) {
        event.stopImmediatePropagation(); updatePrice(event.target, false);
      }
    }, true);
    document.addEventListener('keyup', function (event) {
      if (event.target.matches('[data-filter-range]') && inScope(event.target)) event.stopImmediatePropagation();
    }, true);
    document.addEventListener('submit', function (event) {
      if (event.target.matches('.collection-filters__price-range-form') && inScope(event.target)) {
        stop(event);
        var input = event.target.querySelector('[data-filter-range]');
        if (input) updatePrice(input, true);
      }
    }, true);
    window.addEventListener('popstate', function (event) {
      var target = new URL(window.location.href);
      if (!isCollectionUrl(target, originalUrl)) return;
      var stored = event.state && event.state[historyKey];
      navigate(target, { pop: true, scroll: stored && stored.scroll });
    });
    root.dataset.larkCollectionNavigation = 'ready';
    root.dataset.larkCollectionUpdates = '0';
    saveScroll();
  }
  // empire.js is asynchronous; its section and modal handlers must exist first.
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}());
